export default {
  path: "/dashboard",
  name: "dashboard_base",
  component: () => import("@/views/dashboard/DashboardBase.vue"),
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: "applications",
      name: "applicant_dashboard_applications",
      component: () => import("@/views/dashboard/ApplicantApplications.vue"),
      meta: {
        showTabs: false
      }
    },
    {
      path: "applicant/view/:id",
      name: "applicant_dashboard_view_application",
      component: () => import("@/views/dashboard/ApplicantViewApplicationBase.vue"),
      children: [
        {
          path: "application",
          name: "applicant_dashboard_view_application_application",
          component: () => import("@/views/dashboard/view_application/Application.vue")
        },
        {
          path: "report/:type",
          name: "applicant_dashboard_view_application_report",
          component: () => import("@/views/dashboard/view_application/Report.vue")
        }
      ]
    },

    {
      path: "applicants",
      name: "dashboard_applicants",
      component: () => import("@/views/dashboard/applicants/ApplicantsBase.vue"),
      meta: {
        showTabs: true,
        tabs: [
          {
            label: "Submitted",
            route: "dashboard_applicants_submitted"
          },
          {
            label: "Invited",
            route: "dashboard_applicants_invited"
          },
          {
            label: "Archived",
            route: "dashboard_applicants_archived"
          },
          {
            label: "Decided",
            route: "dashboard_applicants_decided"
          }
        ]
      },
      children: [
        {
          path: "submitted",
          name: "dashboard_applicants_submitted",
          component: () =>
            import("@/views/dashboard/applicants/components/ApplicationBundleTable.vue")
        },
        {
          path: "invited",
          name: "dashboard_applicants_invited",
          component: () =>
            import("@/views/dashboard/applicants/components/ApplicationBundleTable.vue")
        },
        {
          path: "archived",
          name: "dashboard_applicants_archived",
          component: () =>
            import("@/views/dashboard/applicants/components/ApplicationBundleTable.vue")
        },
        {
          path: "decided",
          name: "dashboard_applicants_decided",
          component: () =>
            import("@/views/dashboard/applicants/components/ApplicationBundleTable.vue")
        }
      ]
    },
    {
      path: "forms",
      name: "dashboard_forms",
      component: () => import("@/views/dashboard/forms/Forms.vue")
    },
    {
      path: "forms/flyer",
      name: "dashboard_forms_flyer",
      component: () => import("@/views/dashboard/forms/Flyer.vue"),
      meta: {
        displayBackButton: true
      }
    },
    {
      path: "forms/new",
      name: "dashboard_new_form",
      component: () => import("@/views/dashboard/new_form/NewFormBase.vue"),
      children: [
        {
          path: "reports",
          name: "dashboard_new_form_reports",
          component: () => import("@/views/dashboard/new_form/SelectReports.vue")
        },
        {
          path: "name",
          name: "dashboard_new_form_name",
          component: () => import("@/views/dashboard/new_form/CreateLink.vue")
        }
      ]
    },
    {
      path: "forms",
      name: "dashboard_form_base",
      component: () => import("@/views/dashboard/form/FormBase.vue"),
      meta: {
        displayBackButton: true,
        showTabs: true,
        tabs: [
          {
            label: "Form settings",
            route: "dashboard_form_settings"
          },
          {
            label: "Form editor",
            route: "dashboard_form_edit"
          }
        ]
      },
      children: [
        {
          path: ":slug/settings",
          name: "dashboard_form_settings",
          component: () => import("@/views/dashboard/form/FormSettings.vue")
        },
        {
          path: ":slug/edit",
          name: "dashboard_form_edit",
          component: () => import("@/views/dashboard/form/FormEdit.vue")
        }
      ]
    },

    {
      path: "view/:id",
      name: "dashboard_view_application",
      alias: "view/:id/:token?",
      component: () => import("@/views/dashboard/view_application/ViewApplicationBase.vue"),
      children: [
        {
          path: "summary",
          name: "dashboard_view_application_summary",
          component: () => import("@/views/dashboard/view_application/Summary.vue")
        },
        {
          path: "application",
          name: "dashboard_view_application_application",
          component: () => import("@/views/dashboard/view_application/Application.vue")
        },
        {
          path: "report/:type",
          name: "dashboard_view_application_report",
          component: () => import("@/views/dashboard/view_application/Report.vue")
        },
        {
          path: "documents/",
          name: "dashboard_view_application_documents",
          component: () => import("@/views/dashboard/view_application/Documents.vue")
        }
        // {
        //   path: ":token?",
        //   name: "dashboard_view_application_share_redirect",
        //   beforeEnter: (to, from) => {

        //   }
        // }
      ]
    },
    {
      path: "my_payments",
      name: "dashboard_my_payments",
      component: () => import("@/views/dashboard/my_payments/MyPaymentsBase.vue"),
      children: [
        {
          path: "not_enabled",
          name: "dashboard_my_payments_not_enabled",
          component: () => import("@/views/dashboard/my_payments/NotEnabled.vue")
        },
        {
          path: "accounts",
          name: "dashboard_my_payments_accounts",
          component: () => import("@/views/dashboard/my_payments/Accounts.vue")
        },
        {
          path: "signup",
          name: "dashboard_my_payments_signup",
          component: () => import("@/views/dashboard/my_payments/signup/SignupBase.vue"),
          children: [
            {
              path: "bank_account_info",
              name: "dashboard_my_payments_signup_bank_account_info",
              component: () => import("@/views/dashboard/my_payments/signup/BankAccountInfo.vue")
            },
            {
              path: "pay",
              name: "dashboard_my_payments_signup_pay",
              component: () => import("@/views/dashboard/my_payments/signup/Pay.vue")
            },
            {
              path: "complete",
              name: "dashboard_my_payments_signup_complete",
              component: () => import("@/views/dashboard/my_payments/signup/Complete.vue")
            }
          ]
        }
      ]
    },
    {
      path: "settings",
      name: "dashboard_settings",
      component: () => import("@/views/dashboard/settings/SettingsBase.vue"),
      children: [
        {
          path: "profile",
          name: "dashboard_settings_profile",
          component: () => import("@/views/dashboard/settings/Profile.vue")
        },
        {
          path: "notifications",
          name: "dashboard_settings_notifications",
          component: () => import("@/views/dashboard/settings/Notifications.vue")
        },
        {
          path: "password",
          name: "dashboard_settings_password",
          component: () => import("@/views/dashboard/settings/Password.vue")
        },
        {
          path: "bank_account",
          name: "dashboard_settings_bank_account",
          component: () => import("@/views/dashboard/settings/BankAccount.vue")
        }
      ]
    },
    {
      path: "verify",
      name: "dashboard_verify",
      component: () => import("@/views/dashboard/verify/VerifyBase.vue"),
      children: [
        {
          path: "disclaimer",
          name: "dashboard_verify_disclaimer",
          component: () => import("@/views/dashboard/verify/Disclaimer.vue")
        },
        {
          path: "personal_info",
          name: "dashboard_verify_personal_info",
          component: () => import("@/views/dashboard/verify/PersonalInfo.vue")
        },
        {
          path: "questions",
          name: "dashboard_verify_questions",
          component: () => import("@/views/dashboard/verify/Questions.vue")
        },
        {
          path: "success",
          name: "dashboard_verify_success",
          component: () => import("@/views/dashboard/verify/Success.vue")
        },
        {
          path: "failure",
          name: "dashboard_verify_failure",
          component: () => import("@/views/dashboard/verify/Failure.vue")
        }
      ]
    },
    {
      path: "teams",
      name: "dashboard_teams",
      component: () => import("@/views/dashboard/teams/Teams.vue")
    },
    {
      path: "notifications",
      name: "dashboard_notifications",
      component: () => import("@/views/dashboard/notifications/NotificationPage.vue")
    },
    {
      path: "documents",
      name: "dashboard_documents",
      component: () => import("@/views/dashboard/documents/Documents.vue"),
      children: [
        {
          path: "templates",
          name: "dashboard_documents_templates",
          component: () => import("@/views/dashboard/documents/components/Templates.vue")
        },
        {
          path: "sent",
          name: "dashboard_documents_sent",
          component: () => import("@/views/dashboard/documents/components/Sent.vue")
        }
      ]
    },
    {
      path: "documents/:id/view",
      name: "dashboard_documents_view",
      component: () => import("@/views/dashboard/documents/ViewDocument.vue")
    },
    {
      path: "documents/:id/edit",
      name: "dashboard_documents_edit",
      component: () => import("@/views/dashboard/documents/EditDocument.vue")
    },
    {
      path: "signings/:id/view",
      name: "dashboard_signing_view",
      component: () => import("@/views/dashboard/signing/ViewSigning.vue")
    },
    {
      path: "documents/new",
      name: "dashboard_new_document",
      component: () => import("@/views/dashboard/new_document/NewDocumentBase.vue"),
      children: [
        {
          path: "name",
          name: "dashboard_new_document_name",
          component: () => import("@/views/dashboard/new_document/Name.vue")
        },
        {
          path: "fields",
          name: "dashboard_new_document_fields",
          component: () => import("@/views/dashboard/new_document/Fields.vue")
        }
      ]
    }
  ]
}
